import mutations from './accountStatusMutation';
import actions from './accountStatusAction';
import getters from './accountStatusGetter';

const state= {
  accountStatusTrendList: [],
  accountStatusDiffList: [],
  accountStatusCspList: [],
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/monitoring/cloudaccount/status/accountStatusStore.js